export default __webpack_public_path__ + "tea.png?3e25a8d70d987f2bbf2fa4319bd3886c";